import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { formatInterestRate } from '@/localization/percentages';
import Button from '@/ui-kit/components/Button/Button';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList/DataList';

type Payload = { creditLimit: number; interest: number };
type Props = ModalProps<Payload>;

const LevlaOfferSuccess = ({ closeModal, payload: { creditLimit, interest } }: Props) => {
  const { t } = useTranslation(['Modal', 'Common', 'Button']);

  return (
    <Modal title={t('LevlaOfferSuccess.title')}>
      <p>{t('LevlaOfferSuccess.info')}</p>
      <DataList>
        <DataListItem>
          <DataListLabel>{t('LevlaOfferSuccess.infoItemTitle1')}</DataListLabel>
          <DataListValue>{t('Common:money', { amount: creditLimit })}</DataListValue>
        </DataListItem>
        <DataListItem>
          <DataListLabel>{t('LevlaOfferSuccess.infoItemTitle2')}</DataListLabel>
          <DataListValue>{formatInterestRate(interest)}</DataListValue>
        </DataListItem>
      </DataList>
      <ModalActions>
        <Button onClick={closeModal}>{t('Button:clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default LevlaOfferSuccess;
